/**
 * Returns a random item from an array
 *
 * @param {Array} arr - Array to pick item from
 *
 * @return {mixed} - Random item from array
 */
export const arraySample = (arr) => {
  return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Calculates similarity in percent between two points on the same range
 *
 * @param {number} point1 - First point value on range
 * @param {number} point2 - Second point value on range
 * @param {number} rangeMin - Minimum range value
 * @param {number} rangeMax - Maximum range value
 *
 * @sample: on a scale of 1-5, the similarity between points 4 & 5 is 75%. similarity between points 1 & 5 is 0%.
 *
 * @return {number} - Similarity in percentage.
 */
export const calculateRangePercentage = (point1, point2, rangeMin, rangeMax) => {
  //formula:
  //100 - abs(score_answer - user_answer) * (100/(slider_max - slider_min))
  return 100 - Math.abs(point1 - point2) * (100 / (rangeMax - rangeMin));
}

export const scrollToRef = (ref) => ref.current.scrollIntoView({behavior: 'smooth'});
